// Maps legacy (old Weebly site) URLs to the new site structure.
import { SERVICE_AREAS, slugify } from '../data/mock';

// Explicit one-to-one legacy page mappings
const STATIC_MAP = {
  '/blank.html': '/',
  '/apps': '/',
  '/apps/': '/',
  '/mold-inspections--testing.html': '/mold-inspection',
  '/mold-inspection-services.html': '/mold-inspection',
  '/infrared-ir-thermal-imaging.html': '/mold-inspection',
  '/locating-roof-leaks.html': '/mold-inspection',
  '/inspecting-for-air-leaks.html': '/air-quality',
  '/indoor-air-quality-testing.html': '/air-quality',
  '/mold--indoor-air-quality.html': '/air-quality',
  '/about-us.html': '/about',
  '/home.html': '/',
  '/index.html': '/',
};

// Old slugs that don't cleanly map to a new city slug
const SLUG_FIXES = {
  'st-catherines': 'st-catharines', // old site spelled it "catherines"
};

// Precompute valid new city slugs for validation
const VALID_CITY_SLUGS = new Set(SERVICE_AREAS.map((c) => slugify(c)));

const CITY_SUFFIX = '-mold-inspections--air-quality-testing.html';

export function resolveLegacyPath(pathname) {
  if (!pathname) return null;
  // normalise: decode, lowercase, strip trailing slash (except root)
  let p = decodeURIComponent(pathname).toLowerCase();
  if (p.length > 1 && p.endsWith('/')) p = p.slice(0, -1);

  // 1) Static page mappings
  if (STATIC_MAP[p]) return STATIC_MAP[p];

  // 2) City location pages: /<city>-mold-inspections--air-quality-testing.html
  if (p.endsWith(CITY_SUFFIX)) {
    let citySlug = p.slice(1, p.length - CITY_SUFFIX.length); // drop leading '/'
    citySlug = SLUG_FIXES[citySlug] || citySlug;
    if (VALID_CITY_SLUGS.has(citySlug)) return `/service-areas/${citySlug}`;
    return '/service-areas'; // unknown city -> all areas
  }

  // 3) Any other old .html page -> home (avoids dead ends)
  if (p.endsWith('.html')) return '/';

  return null;
}
